import Footer from '../../../components/Footer';
import { Layout } from '../../../components/layout';
import ButtonBack from '../../../components/ui/buttonBack';
import {
	choosePlatform,
	choosePlatformDomainName,
	choosePlatformName,
} from '../../../helpers/utils';

export const TransparencyPortal = () => {
	return (
		<Layout customBG="bg-background-dark" logoWhite>
			<div className="px-3.5 pt-7 pb-7 lg:max-w-screen-xl lg:mx-auto">
				<div className="items-center flex-row flex justify-between px-3.5 pt-10 pb-6 lg:flex-col lg:justify-start lg:items-start lg:gap-4">
					<ButtonBack classNameIcon="text-custom-white" />
					<p
						className={
							'text-xl font-semibold text-center font-bahnschrift text-custom-white lg:text-left' +
							(choosePlatform()
								? ' lg:text-white'
								: ' lg:text-primary')
						}
					>
						Canal da Transparência
					</p>
					<div></div>
				</div>

				<div className="text-sm text-left text-custom-gray4 font-bahnschrift lg:rounded-lg lg:bg-custom-gray2 lg:p-8">
					O Canal da Transparência é o meio oficial e exclusivo do
					{choosePlatformName()} para o recebimento de denúncias e
					solicitações específicas relacionadas a temas de Compliance
					e Proteção de Dados Pessoais. Esse canal foi criado para
					garantir a integridade, a ética e a transparência em todas
					as nossas operações, bem como para assegurar o cumprimento
					da Lei Geral de Proteção de Dados Pessoais (LGPD). Para
					garantir o uso correto deste canal, apresentamos abaixo as
					diretrizes de sua utilização:
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							I) Envio de Relatos sobre Violações ao Código de
							Ética e Conduta
						</span>
					</p>
					<br />
					<br />O Canal da Transparência deve ser utilizado para
					reportar qualquer tipo de violação ao nosso Código de Ética
					e Conduta. As denúncias podem ser feitas de forma anônima ou
					identificada, garantindo total confidencialidade e proteção
					ao denunciante. O Código de Ética está disponível para
					consulta no seguinte link: Código de Ética e Conduta do
					{choosePlatformName()}.
					<br />
					<br />
					Entre as infrações que podem ser reportadas, destacam-se:
					<br />
					• Prática de Corrupção e Suborno: Envolvimento em atos
					ilícitos que visem obter vantagens indevidas, incluindo
					oferecimento ou recebimento de propinas.
					<br />
					• Assédio Moral e Sexual: Comportamentos inadequados que
					desrespeitem a dignidade dos colaboradores, criando
					ambientes hostis ou ofensivos.
					<br />• Agressões Físicas: Qualquer ato de violência física
					no ambiente de trabalho ou em atividades relacionadas ao
					{choosePlatformName()}.
					<br />
					• Fraudes e Irregularidades Financeiras: Manipulação de
					informações contábeis, desvio de recursos ou qualquer outra
					prática que comprometa a integridade financeira da
					organização.
					<br />
					• Discriminação e Preconceito: Atitudes discriminatórias com
					base em raça, gênero, orientação sexual, religião, entre
					outros.
					<br />
					<br />
					Todas as denúncias serão analisadas de forma criteriosa pela
					equipe de Compliance, assegurando a adoção das medidas
					cabíveis para a correção das irregularidades.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							II) Solicitações de Titulares de Dados Pessoais
						</span>
					</p>
					<br />
					Em conformidade com a Lei Geral de Proteção de Dados
					Pessoais (Lei nº 13.709/2018), o Canal da Transparência
					também deve ser utilizado para o envio de solicitações por
					parte dos titulares de dados pessoais. Estas solicitações
					podem incluir:
					<br />• Acesso aos Dados: Solicitação para saber quais dados
					pessoais estão sendo tratados pelo {choosePlatformName()}.
					<br />
					• Correção de Dados Incompletos, Inexatos ou Desatualizados:
					Pedido para corrigir informações incorretas.
					<br />
					• Anonimização, Bloqueio ou Eliminação de Dados
					Desnecessários ou Excessivos: Requerimento para garantir que
					os dados tratados estejam adequados aos princípios da LGPD.
					<br />• Portabilidade de Dados: Transferência de dados
					pessoais para outro fornecedor de serviços ou produtos.
					<br />• Revogação do Consentimento: Retirada do
					consentimento previamente concedido para o tratamento de
					dados pessoais.
					<br />• Informações sobre Compartilhamento de Dados:
					Esclarecimentos sobre com quem e para quais finalidades os
					dados estão sendo compartilhados.
					<br />
					<br />
					As solicitações serão direcionadas ao nosso Encarregado de
					Proteção de Dados (DPO), responsável por garantir o
					cumprimento da LGPD e pela interação com a Autoridade
					Nacional de Proteção de Dados (ANPD).
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							Atendimentos Não Relacionados a Compliance ou
							Proteção de Dados Pessoais:
						</span>
					</p>
					<br />
					<br />
					Se o seu contato não estiver relacionado a denúncias de
					violações ao Código de Ética e Conduta ou a solicitações de
					titulares de dados pessoais, recomendamos que utilize outros
					canais de comunicação do {choosePlatformName()}, conforme
					descrito abaixo:
					<br />
					• Chat Online: Disponível tanto em nosso aplicativo quanto
					na versão web, para suporte técnico, dúvidas sobre serviços
					e informações gerais.
					<br />• E-mail: Envie sua solicitação para suporte@
					{choosePlatformDomainName()}
					para assuntos diversos, como problemas técnicos, dúvidas
					sobre o uso da plataforma, entre outros.
					<br />• Redes Sociais: Entre em contato através de nossos
					perfis oficiais no Facebook, Twitter e Instagram para
					informações rápidas e atualizações sobre o{' '}
					{choosePlatformName()}.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							Compromisso com a Transparência e a Ética
						</span>
					</p>
					<br />O {choosePlatformName()} valoriza a transparência, o
					respeito aos direitos dos colaboradores e usuários, e o
					cumprimento das leis aplicáveis. O uso correto do Canal da
					Transparência é fundamental para mantermos um ambiente ético
					e seguro para todos. Garantimos que todas as denúncias e
					solicitações serão tratadas com a máxima confidencialidade,
					respeitando os direitos de todas as partes envolvidas.
					<br />
					<br />
					Caso tenha dúvidas sobre o uso do Canal da Transparência ou
					sobre o processo de tratamento de denúncias e solicitações,
					não hesite em consultar o nosso Código de Ética e Conduta ou
					entrar em contato com a equipe de Compliance.
					<br />
					<br />
				</div>
			</div>

			<Footer />
		</Layout>
	);
};
